import React from "react";
import RangeSlider from "../Slider";
import SupportingText from "../SupportingText";

export default function SliderContainer({
  label,
  unit,
  upperBound,
  lowerBound,
  min,
  max,
  onSliderChange,
  onAfterChange,
  disabled
}) {
  return (
    <div className="w-full py-2 bg-white">
      <div className="w-full flex flex-start justify-between">
        <SupportingText textColor="black" textSize="base">
          {label}
        </SupportingText>
        <div className="flex ml-auto">
          <div className="flex">
            <SupportingText textColor="black" textSize="sm">
              {lowerBound}
            </SupportingText>
            <SupportingText textColor="black" textSize="sm">
              {unit}
            </SupportingText>
          </div>
          <div className="mx-1">
            <SupportingText textColor="black" textSize="sm">
              -
            </SupportingText>
          </div>
          <div className="flex">
            <SupportingText textColor="black" textSize="sm">
              {upperBound}
            </SupportingText>
            <SupportingText textColor="black" textSize="sm">
              {unit}
            </SupportingText>
          </div>
        </div>
      </div>
      <div className="pt-6 px-6">
        <RangeSlider
          value={[lowerBound, upperBound]}
          min={min}
          max={max}
          handleChange={onSliderChange}
          handleOnAfterChange={onAfterChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/SliderContainer/SliderContainer.js